import React from "react"
import {FormattedMessage} from "@irati/utils/lang"
import LimitInfo from "../styled/LimitInfo"

export default () => (
  <LimitInfo>
    <FormattedMessage id="perks.components.productForms.maxProductsReached.text" />
  </LimitInfo>
)
